module.exports = __webpack_public_path__ + "static/img/9.771567f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/2/sp/9.png
// module id = wnUg
// module chunks = 0